import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { CheckCircle2, Loader2 } from "lucide-react";

export default function BillingSuccess() {
  const { refreshUser } = useAuth();
  const navigate = useNavigate();
  const [ok, setOk] = useState(false);

  useEffect(() => {
    let tries = 0;
    const poll = async () => {
      const u = await refreshUser();
      if (u?.company?.entitled) {
        setOk(true);
        setTimeout(() => navigate("/"), 1500);
        return;
      }
      if (tries++ < 8) setTimeout(poll, 2000);
      else { setOk(true); setTimeout(() => navigate("/"), 1500); }
    };
    poll();
  }, []);

  return (
    <div className="flex min-h-screen items-center justify-center bg-background p-8">
      <div className="w-full max-w-md border border-border bg-card p-10 text-center animate-fade-up">
        {ok ? <CheckCircle2 size={48} className="mx-auto mb-4 text-emerald-400" /> : <Loader2 size={48} className="mx-auto mb-4 animate-spin text-primary" />}
        <h1 className="font-display text-2xl font-bold">{ok ? "Abonnement activé !" : "Activation en cours…"}</h1>
        <p className="mt-2 text-sm text-muted-foreground">
          {ok ? "Redirection vers votre espace…" : "Merci de patienter quelques instants."}
        </p>
      </div>
    </div>
  );
}
